import React, { useState } from 'react';
import styles from '../EmpoweringIndustries/EmpoweNavbar.module.css';


const EmpoweNavbar = () => {
    const [open, setOpen] = useState(false);


    return (
        <>
            <div className={styles.container}>
                <nav className={styles.navbar}>
                    <div className={styles.left}>
                        <img
                            src="/svg/logo-new.svg"
                            alt="Rexpt-Logo"
                            className={styles.logo}
                        />
                    </div>


                    <ul className={styles.menu}>
                        <li onClick={() => window.open("https://rxpt.ai/features", "_blank")}>
                            Features
                        </li>
                        <li onClick={() => window.open("https://rxpt.ai/pricing", "_blank")}>
                            Pricing
                        </li>
                        <li onClick={() => window.open("https://rxpt.ai/industries", "_blank")}>
                            Industries
                        </li>
                    </ul>

                    {/* Hamburger */}
                    <div
                        className={`${styles.hamburger} ${open ? styles.active : ""}`}
                        onClick={() => setOpen(!open)}
                    >
                        <span></span>
                        <span></span>
                    </div>
                </nav>


                {/* Overlay */}
                {open && <div className={styles.overlay} onClick={() => setOpen(false)}></div>}


                {/* Right Side Mobile Menu */}
               <div className={`${styles.mobileMenu} ${open ? styles.open : ""}`}>
    <ul>
        <li
            onClick={() => {
                setOpen(false);
                window.open("https://rxpt.ai/features", "_blank");
            }}
        >
            Features
        </li>

        <li
            onClick={() => {
                setOpen(false);
                window.open("https://rxpt.ai/pricing", "_blank");
            }}
        >
            Pricing
        </li>

        <li
            onClick={() => {
                setOpen(false);
                window.open("https://rxpt.ai/industries", "_blank");
            }}
        >
            Industries
        </li>
    </ul>
</div>

            </div>
        </>
    );
};


export default EmpoweNavbar;